import { useEffect } from "react";

export type WindowResizeEvent =
  | (UIEvent & {
      target: Window;
      currentTarget: Window;
    })
  | undefined;

export const useWindowResize = (
  onResize: (event?: WindowResizeEvent) => void,
) => {
  useEffect(() => {
    const handleResize = (event: UIEvent) => {
      onResize(event as WindowResizeEvent);
    };

    window.addEventListener("resize", handleResize);
    onResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [onResize]);
};
